import PropTypes from 'prop-types';
import { formatDate } from '../utils/dateUtils';

function HistoryPanel({ diagrams, onLoadDiagram, onDeleteDiagram }) {
  if (diagrams.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state__icon">📋</div>
        <p className="empty-state__text">No saved diagrams yet</p>
      </div>
    );
  }

  return (
    <div className="history-list">
      {diagrams.map(diagram => (
        <div key={diagram.id} className="history-item">
          <div className="history-item__info">
            <h4
              className="history-item__name"
              onClick={() => onLoadDiagram(diagram.code)}
            >
              {diagram.name}
            </h4>
            <p className="history-item__meta">
              {diagram.type} • {formatDate(diagram.updatedAt)}
            </p>
          </div>
          <div className="history-item__actions">
            <button
              className="btn btn--sm btn--secondary"
              onClick={() => onDeleteDiagram(diagram.id)}
              title="Delete diagram"
            >
              🗑️
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

HistoryPanel.propTypes = {
  diagrams: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    updatedAt: PropTypes.number.isRequired
  })).isRequired,
  onLoadDiagram: PropTypes.func.isRequired,
  onDeleteDiagram: PropTypes.func.isRequired
};

export default HistoryPanel;
